import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import qs from 'qs';

import { searchSubs } from 'actions/simoSubs';
import { updateDevice } from 'actions/simoDevices';
import {
  getIsAdmin,
  getPageCount,
  getSearchSimoSubs,
  getSimoDeviceDiagnostics,
} from 'reducers';
import Spinner from 'components/Spinner';
import SimoDeviceTable from 'components/simo/SimoDeviceTable';
import SimoSubsList from 'components/simo/SimoSubsList';
import Pagination from 'components/Pagination/Pagination';
import simoDevicePage from 'decorators/simoDevicePage';
import SimoDeviceActions from 'components/simo/SimoDeviceActions';
import { prettyKey } from 'helpers/formatters';
import FormError from 'components/FormError';
import { hasComma } from 'helpers/validators';
import DiagnosticInfo from '../DiagnosticInfo';

import styles from './styles.module.scss';

class ViewSimoDevice extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.loadDeviceSubs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.subsPage !== this.props.subsPage) {
      this.loadDeviceSubs();
    }
  }

  loadDeviceSubs = async () => {
    const { searchSubs, simoDeviceId, subsPage } = this.props;
    try {
      await searchSubs(subsPage, { device: simoDeviceId });
    } catch (e) {
      toast.error('Failed to load subs');
    }
  };

  handleUpdateField = (name, value) => {
    const { simoDeviceId, updateDevice } = this.props;

    if (['name'].includes(name) && hasComma(value)) {
      toast.error(`${prettyKey(name)}: comma sign is not allowed`);
      return;
    }

    this.setState({ loading: true });
    updateDevice(simoDeviceId, { [name]: value })
      .then(() => {
        toast.success(`Device ${prettyKey(name)} Updated`);
        this.setState({ loading: false });
      })
      .catch((e) => {
        if (e.errors) {
          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      simoDeviceId,
      simoDevice,
      diagnostic,
      subs,
      subsPageCount,
      subsPage,
      simoDeviceLoading,
      loggedInUser,
    } = this.props;
    const { loading } = this.state;

    const isExpired = simoDevice?.simo_status === 'expired';

    if (!simoDeviceLoading && !simoDevice) {
      return <div>Not Found</div>;
    }

    return (
      <div>
        <SimoDeviceActions
          simoDevice={simoDevice}
          loggedInUser={loggedInUser}
          loadDeviceSubs={this.loadDeviceSubs}
        />
        <div className={styles.header}>
          <h1 className={styles.title}>Simo Device</h1>
          {!isExpired && (
            <Link
              to={`/users/${simoDevice?.user_profile}/simo/new-subscription?device_id=${simoDevice?.id}&device_sn=${simoDevice?.serial_number}`}
            >
              <button className="btn btn-default">Add Simo Subscription</button>
            </Link>
          )}
        </div>
        <p className="links">
          <Link to={`/users/${simoDevice?.user_profile}/view`}>
            &larr; Back to User
          </Link>
        </p>
        <div className="relative">
          <SimoDeviceTable
            simoDevice={simoDevice}
            diagnostic={diagnostic}
            handleUpdateField={this.handleUpdateField}
          />
          <Spinner showLoader={loading} />
        </div>
        <br />
        <SimoSubsList
          subs={subs}
          viewUrl={(id) => `/simo/subscriptions/${id}/view`}
        />
        <Pagination
          count={subsPageCount}
          current={subsPage}
          url={(pageNum) =>
            `/simo/devices/${simoDeviceId}/view?subsPage=${pageNum}`
          }
        />
        {!isExpired && simoDevice && (
          <DiagnosticInfo
            userId={simoDevice?.user_profile}
            simoDeviceId={simoDeviceId}
          />
        )}
        <Spinner showLoader={simoDeviceLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { location, simoDeviceId }) => {
  const search = location?.search;
  const { subsPage = '1' } = qs.parse(search, { ignoreQueryPrefix: true });

  return {
    subs: getSearchSimoSubs(state, subsPage),
    subsPageCount: getPageCount(state, 'simoSubs', `searchSubs`, subsPage),
    subsPage,
    isAdmin: getIsAdmin(state),
    diagnostic: getSimoDeviceDiagnostics(state, simoDeviceId),
  };
};

const mapDispatchToProps = {
  searchSubs,
  updateDevice,
};

export default simoDevicePage(
  connect(mapStateToProps, mapDispatchToProps)(ViewSimoDevice),
);
